export const TILE_CHANGE = 'TILE_CHANGE';
export const ADD_SESSION = 'ADD_SESSION';
export const ACTION_LOGOUT_INITIATED = 'ACTION_LOGOUT_INITIATED';
export const UPDATE_STATS = 'UPDATE_STATS';
export const UPDATE_GRAPH_STATS = 'UPDATE_GRAPH_STATS';
export const GET_INVENTORY_ITEMS = 'GET_INVENTORY_ITEMS';
export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
export const UPDATE_SUPPLIER_LIST = 'UPDATE_SUPPLIER_LIST';
export const UPDATE_SUPPLIER_MAP = 'UPDATE_SUPPLIER_MAP';
export const START_SPINNER = 'START_SPINNER';
export const STOP_SPINNER = 'STOP_SPINNER';
export const GET_ORDER_ITEMS = 'GET_ORDER_ITEMS';
export const UPDATE_ORDER_DETAILS = 'UPDATE_ORDER_DETAILS';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';

export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const RESET_STATE = 'RESET_STATE';

export const FETCH_INVENTORY_ITEMS = 'FETCH_INVENTORY_ITEMS';
export const DELETE_INVENTORY = 'DELETE_INVENTORY';
export const FETCH_BUCKET_LIST = 'FETCH_BUCKET_LIST';
export const CREATE_BUCKET = 'CREATE_BUCKET';
export const CLONE_BUCKET = 'CLONE_BUCKET';
export const UPDATE_BUCKET_ORDER = 'UPDATE_BUCKET_ORDER';
export const UPDATE_BUCKET_PRICE = 'UPDATE_BUCKET_PRICE';
export const UPDATE_BUCKET = 'UPDATE_BUCKET';
export const UPDATE_BUCKETS = 'UPDATE_BUCKETS';
export const UPDATE_STATUS = 'UPDATE_STATUS';
export const DELETE_BUCKET = 'DELETE_BUCKET';
export const SET_UPLOAD_INVENTORY_FILE_ACTION = 'SET_UPLOAD_INVENTORY_FILE_ACTION';
export const SET_UPLOAD_INVENTORY_FILE_BATCH = 'SET_UPLOAD_INVENTORY_FILE_BATCH';
export const SET_UPLOAD_ORDERS_FILE_ACTION = 'SET_UPLOAD_ORDERS_FILE_ACTION';
export const SET_UPLOAD_ORDERS_FILE_BATCH = 'SET_UPLOAD_ORDERS_FILE_BATCH';
export const SET_MANUFACTURER_OPTIONS = 'SET_MANUFACTURER_OPTIONS';
export const SET_PACKAGING_OPTIONS = 'SET_PACKAGING_OPTIONS';
export const SET_MAPPED_SUPPLIER_OPTIONS = 'SET_MAPPED_SUPPLIER_OPTIONS';
export const SET_MAPPED_DSO_OPTIONS = 'SET_MAPPED_DSO_OPTIONS';
export const SET_CATEGORY_OPTIONS = 'SET_CATEGORY_OPTIONS';
export const SET_SUBCATEGORY_OPTIONS = 'SET_SUBCATEGORY_OPTIONS';
export const SET_SUBSUBCATEGORY_OPTIONS = 'SET_SUBSUBCATEGORY_OPTIONS';

export const FETCH_DSO_LIST = 'FETCH_DSO_LIST';
export const MAP_DSO = 'MAP_DSO';
export const UPDATE_DSO_CONFIG = 'UPDATE_DSO_CONFIG';

export const SET_PROCEDURES = 'SET_PROCEDURES';
export const SET_PROCEDURE_ENUMS = 'SET_PROCEDURE_ENUMS';
export const SET_DENTIRA_PRODUCT_NAME_TO_ID_MAP = 'SET_DENTIRA_PRODUCT_NAME_TO_ID_MAP';

export const FETCH_RECOMMENDED_AI_SKU_MAPPINGS = 'FETCH_RECOMMENDED_AI_SKU_MAPPINGS';
export const APPROVE_AI_SKU_MAPPING = 'APPROVE_AI_SKU_MAPPING';
export const REJECT_AI_SKU_MAPPING = 'REJECT_AI_SKU_MAPPING';
export const UPDATE_AI_SKU_MAPPING = 'UPDATE_AI_SKU_MAPPING';
export const DECREMENT_UNREVIEWED_RECOMMENDATIONS_COUNT = 'DECREMENT_UNREVIEWED_RECOMMENDATIONS_COUNT';
